import React, { useCallback, useEffect, useRef, useState, Suspense, lazy } from 'react'
import { useNavigate } from 'react-router-dom'

// Styles
import style from './Mining.module.css'

// Downloads files
import Withdrawal from '../../assets/Icons/withdrawal.svg?react'
import CoinIcon from '../../assets/Task_new_icons/task-coins.svg?react'
import couponLogo from '/couponLogo.svg'
// Stores
import useApplicationSettings from '../Store/ApplicationSettings.js'
import useUserStore from '../Store/UserStore.js'
import { useNotificationStore } from '../Store/NotificationStore.ts'
import Modal from '../Components/Modal/Modal.tsx'
import DailyRewardModalContent from './DailyReward/DailyRewardModalContent'
import { useModalStore } from '../Store/ModalStore.ts'

// Services
import { getUserData, sendWithdrawalRequest } from '../Services/Requests.ts'
import { getDailyRewards } from '../Services/Requests'
// Components
import Coin from '../Components/Coin/Coin.jsx'
import MiningBar2 from './Mining/components/MiningBar/MiningBar'
import Prestart from '../Components/Prestart/Prestart.jsx'
import QuestIcon from '../Components/QuestIcon/QuestIcon.jsx'
import LoadingWrapper from '../ComponentsWrappers/LoadingWrapper.jsx'
import MaintenancePage from '../Components/MaintenancePage/MaintenancePage'
import WithdrawalModal from '../Components/WithdrawalModal/WithdrawalModal.jsx'
import AnimatedBalance from '../Components/AnimatedBalance/AnimatedBalance'
import BoostModal from '../Pages/Mining/components/BoostModal/BoostModal'
import sponsorsIcon from '../../../public/sponsorcIcon.svg'
import { useTasksStore } from '../Store/TasksStore.ts'
import TasksNotification from '../Components/TasksNotification/TasksNotification'
import tasksFetchIcon from '../../../public/tasksFetchIcon.png'

export default function Mining() {
	const navigate = useNavigate()
	const containerRef = useRef(null)
	const isInitialized = useRef(false)

	// ApplicationSettings
	const setShowMenubar = useApplicationSettings(state => state.setShowMenubar)
	const setDialogMenuContent = useApplicationSettings(state => state.setDialogMenuContent)
	const setPagesMarker = useApplicationSettings(state => state.setPagesMarker)
	const setIsFirstStart = useApplicationSettings(state => state.setIsFirstStart)

	const setNotification = useNotificationStore(state => state.setNotification)

	const handleBoostTasks = tasks => {
		setBoostTasks(tasks)
	}

	const openBoostModal = () => {
		setOpen('boost')
	}

	// UserStore
	const balanceDC = useUserStore(state => state.balanceDC)
	const balanceUSDT = useUserStore(state => state.balanceUSDT)
	const setIsAllTasksComplete = useUserStore(state => state.setIsAllTasksComplete)
	const setQuestEndDate = useUserStore(state => state.setQuestEndDate)
	const setServerTime = useUserStore(state => state.setServerTime)
	const setQuestDataLoaded = useUserStore(state => state.setQuestDataLoaded)
	const tasksSponsors = useTasksStore(state => state.tasks)
	const notStartedTasksSponsors = tasksSponsors.filter(task => task.status === 'NOT_STARTED')
	const showTasksNotification = useTasksStore(state => state.showNotification)
	const setShowTasksNotification = useTasksStore(state => state.setShowNotification)

	const tg = window.Telegram.WebApp

	const onError = useCallback(result => {
		alert(JSON.stringify(result, null, 4))
	}, [])

	const [hasError, setHasError] = useState(false)

	const [withdrawalModal, setWithdrawalModal] = useState({
		isOpen: false,
		isClosing: false,
	})

	const [showBoostModal, setShowBoostModal] = useState(false)
	const { open, handleClose, setOpen } = useModalStore()
	const [dailyRewardOpen, setDailyRewardOpen] = useState(false)
	const [boostTasks, setBoostTasks] = useState([])

	const fetchDailyRewards = async () => {
		const dailyRewardResponse = await getDailyRewards()
		if (dailyRewardResponse) {
			const thisDayPrize = dailyRewardResponse.tasks?.find(item => item.details.current_day)

			if (thisDayPrize?.status === 'NOT_STARTED') {
				setDailyRewardOpen(true)
				setOpen('dailyReward')
			}
		}
	}

	const handleDailyRewardClose = () => {
		setOpen(false)
		setDailyRewardOpen(false)
		handleClose()
	}

	useEffect(() => {
		if (isInitialized.current) return

		setShowMenubar(true)
		let mounted = true

		const initializeData = async () => {
			if (!mounted) return

			try {
				const store = useUserStore.getState()
				fetchDailyRewards()
				isInitialized.current = true
			} catch (error) {
				console.error('Error initializing data:', error)
				if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
					setHasError(true)
				}
			}
		}

		initializeData()

		// Ждем инициализации Telegram WebApp
		if (!window.Telegram?.WebApp?.initDataUnsafe?.user?.id) {
			console.log('Waiting for Telegram WebApp initialization...')
			return
		}

		// Проверяем инициализацию Telegram
		if (!tg?.initDataUnsafe?.user?.id) {
			console.warn('Telegram Web App (tg) object is not fully initialized yet.')
			return // Exit if tg is still not ready
		} else {
			// Call tg methods only after confirming initialization
			tg.BackButton.hide()
			tg.disableVerticalSwipes()
			tg.HapticFeedback.notificationOccurred('success')
		}

		return () => {
			mounted = false
		}
	}, [])

	// Показываем уведомление о заданиях при загрузке страницы
	useEffect(() => {
		if (notStartedTasksSponsors.length > 0) {
			// Используем triggerNotification для правильной логики с таймером
			const triggerNotification = useTasksStore.getState().triggerNotification
			triggerNotification(false)
		}
	}, [notStartedTasksSponsors.length])

	// Показываем страницу обслуживания при ошибке
	if (hasError) {
		return <MaintenancePage />
	}

	const showBalanceWithdrawalMessage = () => {
		if (balanceUSDT < 5) {
			setNotification({
				type: 'Error',
				message: 'Минимальный вывод - 5 USDT',
			})
		} else {
			setWithdrawalModal({
				isOpen: true,
				isClosing: false,
			})
		}
	}

	const handleWithdrawalConfirm = () => {
		sendWithdrawalRequest().then(response => {
			if (response) {
				setNotification({
					type: 'Success',
					message: 'Запрос на вывод создан. Ожидайте подтверждения.',
				})
			} else {
				setNotification({
					type: 'Error',
					message: 'Ваш запрос на вывод уже находится в обработке.',
				})
			}

			// Закрываем модальное окно
			setWithdrawalModal(prev => ({
				...prev,
				isClosing: true,
			}))
			setTimeout(() => {
				setWithdrawalModal({
					isOpen: false,
					isClosing: false,
				})
			}, 300)
		})
	}

	return (
		<>
			<div className={style['container']}>
				<div className={style['shadow']}></div>
				<div className={style['container-wrapper']}>
					<div className={style['header-container']}>
						<div className={style['balance-container']}>
							<div className={style['balances-wrapper']}>
								<div className={style['dc-balance']}>
									<div className={style['coin-wrapper-container']}>
										<div className={style['coin-info']}>
											<div className={style['icon-wrapper-coin']}>
												<CoinIcon></CoinIcon>
											</div>
											<div className={style['coin-count']}>
												<AnimatedBalance value={balanceDC} precision={2} showAnimation={useUserStore(state => state.balanceAnimationEnabled)} />
											</div>
											<div className={style['coin-type']}>DC</div>
										</div>
									</div>
								</div>
								<div className={style['usdt-balance']}>
									<div className={`${style['coin-wrapper-container']} ${style['coin-wrapper-usdt']}`}>
										<div className={style['coin-wrapper-restriction']}>
											<div className={style['coin-info']}>
												<div className={style['icon-wrapper-coin']}>
													<CoinIcon></CoinIcon>
												</div>
												<div className={style['coin-count']}>
													<AnimatedBalance value={balanceUSDT} precision={4} showAnimation={useUserStore(state => state.balanceAnimationEnabled)} />
												</div>
												<div className={style['coin-type']}>USDT</div>
											</div>
										</div>
										<div onClick={showBalanceWithdrawalMessage} className={style['withdrawal-container']}>
											<div className={style['withdrawal-icon-wrapper']}>
												<Withdrawal />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={style['quest-row']}>
							<div className={style['quest-container-left']}>
								<div className={style['tasks-container']} onClick={() => navigate('/tasks/sponsors')}>
									<div className={style['raffle-container-logo-left']}>
										<img src={tasksFetchIcon} alt='raffle' />
									</div>
									<div className={style['raffle-container-text-left']}>
										<p>Задания</p>
									</div>
									<TasksNotification
										isVisible={showTasksNotification}
										taskCount={notStartedTasksSponsors.length}
										onClose={() => setShowTasksNotification(false)}
									/>
								</div>
								<button style={{ backgroundColor: 'transparent' }} onClick={() => navigate('/expedition/3')}>
									Expedition Details
								</button>
							</div>
							<div className={style['quest-container']}>
								<div className={style['quest-container-container']} onClick={() => navigate('/fortune-wheel')}>
									<QuestIcon />
								</div>
								<div className={style['raffle-container']} onClick={() => navigate('/giveaway')}>
									<div className={style['raffle-container-logo']}>
										<img src={couponLogo} alt='raffle' />
									</div>
									<div className={style['raffle-container-text']}>
										<p>Розыгрыши</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className={style['mining']}>
						<div className={style['coin-wrapper']}>
							<LoadingWrapper>
								<Coin></Coin>
							</LoadingWrapper>
						</div>
						<div className={style['miningbar-container']}>
							<div className={style['miningbar-wrapper']}>
								<MiningBar2 />
							</div>
						</div>
					</div>
				</div>
			</div>
			<WithdrawalModal
				isOpen={withdrawalModal.isOpen}
				isClosing={withdrawalModal.isClosing}
				onClose={() => {
					setWithdrawalModal(prev => ({
						...prev,
						isClosing: true,
					}))
					setTimeout(() => {
						setWithdrawalModal({
							isOpen: false,
							isClosing: false,
						})
					}, 300)
				}}
				onConfirm={handleWithdrawalConfirm}
				balanceUSDT={balanceUSDT}
			/>
			{open === 'boost' ? (
				<Modal>
					<BoostModal tasks={boostTasks} onClose={handleClose} />
				</Modal>
			) : null}
			{dailyRewardOpen && open !== 'boost' ? (
				<Modal>
					<DailyRewardModalContent onClose={handleDailyRewardClose} />
				</Modal>
			) : null}
		</>
	)
}
